import { UseFormPayload } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import SuburbSearch from '@components/SuburbSearch'

import type { EntitiesState } from '@redux/entities'

import type { GeoSuburbModel } from '@models/types'

type HandleSelectItemParams = {
  geoStates: EntitiesState['geoStates'],
  geoSuburb: GeoSuburbModel,
  setEntityState: UseFormPayload['setEntityState'],
}

const handleSelectItem = (params: HandleSelectItemParams) => {
  const { geoStates, geoSuburb, setEntityState } = params

  setEntityState({
    country_code: geoStates[geoSuburb.geo_state_id]?.country_code,
    post_code: geoSuburb?.post_code,
    state_name: geoStates[geoSuburb.geo_state_id]?.code,
    suburb_name: geoSuburb?.title,
  })
}

interface SuburbProps {
  campaignComparableForm: UseFormPayload,
  geo_country_id?: number,
}

const Suburb = (props: SuburbProps) => {
  const {
    campaignComparableForm, geo_country_id,
  } = props

  const {
    entityState: {
      suburb_name,
    },
    setEntityState,
  } = campaignComparableForm

  const { geoStates } = useSelector(reduxState => reduxState.entities)

  return (
    <SuburbSearch
      callbacks={{
        onChange: (value: string) => setEntityState({ suburb_name: value }),
        selectItem: (geoSuburb: GeoSuburbModel) => handleSelectItem({ geoStates, geoSuburb, setEntityState }),
      }}
      requestOptions={{ geo_country_id }}
      value={suburb_name}
    />
  )
}

export default Suburb
